import { permissionGuard } from './permission.guard';

/** The Mappings tool. Needs `mappings.view`. */
export const mappingsGuard = permissionGuard((p) => p.has('mappings.view'));
